<template>
  <!----------- 合作院校 end ---------->
  <div class="all_footer_out">
    <div class="container">
      <div class="row index_contact_out">
        <div class="index_contact_add col-lg-6 col-sm-6 col-xs-12">
          <h5>联系我们</h5>
          <ul class="list">
            <li class="a">
              <em></em>内蒙古呼和浩特市金山开发区
            </li>
            <li class="b"><em></em>0471-6653318</li>
            <li class="c"><em></em>Webmaster@immu.edu.cn</li>
          </ul>
        </div>
        <div class="index_contact_map col-lg-6 col-sm-6 col-xs-12">
          <h5></h5>
          <img src="static/images/img-7.png" alt="" />
        </div>
      </div>
    </div>

    <div class="Copyright">
      <p>
        <span>版权所有：内蒙古医科大学 </span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蒙ICP备17000846号-2</a >
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010302000545" target="_blank">蒙公网安备15010302000545号</a>
        <!-- <span
          v-show="pageInformationIsshow"
          v-html="versionNumber"
          style="color: yellow; font-weight: bold"
        >
          版本号：4.0.0</span -->
        <!-- > -->
      </p>
    </div>
  </div>
</template>

<script>
import "../../../static/css/style.css";
import axios from "@/libs/api.request";

export default {
  data() {
    return {
      versionNumber: "", //版本号
      code: "versionNumber",
      pageInformationIsshow: false,
    };
  },
  methods: {
    //获取版本号

    getversionNumber() {
      var that = this;
      var posturl =
        this.config.baseUrl.pro +
        "/Base_Config/apiGetPagedBase_Configs?page=1&limit=1&KeyWord=" +
        this.code;
        console.log(posturl);
      axios
        .request({
          url: posturl,
          methods: "get",
          changeOrigin: true,
        })
        .then((resp) => {
          console.log(resp);
          if (
            resp.data.result.data != null &&
            resp.data.result.data != undefined &&
            resp.data.result.data != ""
          ) {
            this.pageInformationIsshow = true;

            that.versionNumber = "版本号：" + resp.data.result.data[0].value;
            //this.versionNumber = resp.data.result.data[0].remark;
            //this.formData.id = resp.data.result.data[0].id;
          } else {
            this.pageInformationIsshow = false;
          }
        })
        .catch((err) => {
          this.$Message.error("数据加载失败：1" + err);
        });
    },
    getdata() {
      // console.log("数据加载");
    },
    linkclick(url) {
      window.location.href = url;
    },
  },
  mounted() {
    this.getversionNumber();
    this.getdata();
  },
};
</script>
<style scoped>
.link {
  height: 50;
  width: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/webBottom/webBottom.vue